__turbopack_context__.v({
  "pulse": "PmXyQq_pulse",
  "root": "PmXyQq_root",
});
